import React from 'react';
import { observer } from 'mobx-react';
import { Neo, Routing } from '@singularsystems/neo-react';
import InvestorInvestmentVM from './InvestorInvestmentVM';
import NewInvestorInvestmentCommand from '../../Models/InvestorInvestments/Commands/NewInvestorInvestmentCommand';
import IssuerInvestmentAutoComplete from '../../Components/IssuerInvestmentAutoComplete';
import { isHidden } from '../../Models/Config/FieldConfig/FieldSetting.enum';

interface INewInvestorInvestmentProps {
    investorInvestmentVM: InvestorInvestmentVM;
    viewParam: Routing.IViewParameter;
}

@observer
export default class NewInvestorInvestmentModal extends React.Component<INewInvestorInvestmentProps> {

    constructor(props: INewInvestorInvestmentProps) {
        super(props);
    }

    public render() {
        const viewModel = this.props.investorInvestmentVM;
        const fieldSettings = viewModel.dataCache.fieldConfig.investorInvestmentFields;
        
        return (
            <Neo.Modal
                title="New Investment"
                bindModel={viewModel.meta.newInvestorInvestment}
                size="lg"
                acceptButton={{ onClick: () => viewModel.createNewInvestment() }}
                onClose={() => this.props.viewParam.reset()}>
                {(investment: NewInvestorInvestmentCommand) => (
                    <Neo.FormContext labelSizes={{ xs: 3 }}>
                        <Neo.FormGroupInline bindContext={investment.meta.investorId}>
                            <Neo.AutoCompleteDropDown
                                bind={investment.meta.investorId}
                                bindDisplay={investment.lookup.meta.investorName}
                                itemSource={viewModel.investorApiClient.getInvestorLookups}
                                onItemSelected={investor => investment.setInvestor(investor)} />
                        </Neo.FormGroupInline>

                        <Neo.FormGroupInline
                            bind={investment.meta.productTypeId}
                            select={{ itemSource: viewModel.dataCache.productTypes, displayMember: "productTypeCode", onItemSelected: item => investment.setProductType(item) }}
                            hidden={isHidden(fieldSettings.productTypeId)} />

                        <Neo.FormGroupInline
                            bind={investment.meta.entityId}
                            select={{ itemSource: viewModel.dataCache.entities, onItemSelected: item => investment.setEntity(item) }} />

                        {investment.lookup.hasVestingTrust &&
                            <Neo.FormGroupInline bindContext={investment.meta.issuerInvestmentId}>
                                <IssuerInvestmentAutoComplete
                                    bind={investment.meta.issuerInvestmentId}
                                    bindDisplay={investment.lookup.meta.issuerInvestmentName}
                                    entityId={investment.entityId}
                                    productTypeId={investment.productTypeIdParentFilter}
                                    onItemSelected={item => investment.setInvestment(item)}
                                    useParentCache={true} />
                            </Neo.FormGroupInline>
                        }
                    </Neo.FormContext>
                )}
            </Neo.Modal>
        );
    }
}